import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SecurityContext } from "@natera/platform/lib/provider/security";
import { ResultCodes } from "@app/service/resultCodes";
import { routes } from "@app/routing";
import { NotificationContext, UppAuthContext } from "@app/provider";
import { SpinnerView } from "@app/components";
import { useIntl, defineMessages } from "react-intl";

const messages = defineMessages({
  publicSignOutlNotificationTitle: {
    id: "publicSignOutlNotificationTitle",
    defaultMessage: "Sign Out",
  },
  publicSignOutlNotification: {
    id: "publicSignOutlNotification",
    defaultMessage: "You have been successfully signed out",
  },
});

const LogOut: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { logout } = useContext(UppAuthContext);
  const { search } = useLocation();
  const { isAuthorized } = useContext(SecurityContext);
  const { addNotification } = useContext(NotificationContext);
  const [code, setCode] = useState<string | null>(null);
  const isAuth = isAuthorized();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
    (async () => {
      const code = searchParams.get("code");
      setCode(code);
      const isLogoutSuccessful = await logout();
      if (isLogoutSuccessful) {
        addNotification({
          title: intl.formatMessage(messages.publicSignOutlNotificationTitle),
          message: intl.formatMessage(messages.publicSignOutlNotification),
          type: "success",
        });
      }
    })();
  }, []);

  useEffect(() => {
    if (isAuth) return;

    let url = code ? `${routes.logIn}?code=${code}` : routes.logIn;

    if (code === ResultCodes.USER_IS_DELETED) {
      url = `${routes.signUp}?code=${code}`;
    }

    navigate(url);
  }, [isAuth]);

  return <SpinnerView isLoading />;
};
export default LogOut;
